export enum AuditState {
    PENDING = "PENDING", APPROVED = "APPROVED", REJECTED = "REJECTED"
}


// WEBPACK FOOTER //
// ./src/model/AuditState.ts